export const STORE_KEY = '$featureFlags'
export const SET_FLAGS = 'SET_FLAGS'
